import { useEffect, useState } from "react";
import { YSButton } from "../../../uikit/YSButton";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import SendPharmacyIcon from "../../../images/icons/SendPharmacyIcon.svg";
import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";
import PrintIcon from "../../../images/icons/PrintIcon.svg";
import LockIcon from "@mui/icons-material/Lock";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import TrashIcon from "../../../images/icons/TrashIcon.svg";
import Checkbox from "@mui/material/Checkbox";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Collapse from "@mui/material/Collapse";
import {
  AlertInfo,
  BtnGroupStyle,
  HtmlTooltip,
  SummaryBox,
  SummaryBoxScroll,
  SummaryBtns,
  SummaryInfo,
} from "../../../Theme";
import ShowIcon from "@mui/icons-material/Add";
import HideIcon from "@mui/icons-material/Remove";
import { Formik, Form } from "formik";
import { useNavigate } from "react-router";
import { DialogPopup } from "../../../components/DialogPopup";
import moment from "moment";
import YSSnackBar from "../../../uikit/YSSnackBar";
import AlertInfoIcon from "../../../images/icons/AlertInfoIcon.svg";
import { useDispatch, useSelector } from "react-redux";
import DrugAllergyInteractions from "../../../components/DrugAllergyInteractions";
import { loadingTopRibbon } from "../../../Redux/Slice/TopRibbonSlice";
import { REPORT_BASE_URL } from "../../../Apis/Constants";
import { freeTextPrint, freeTextPrintAndFax } from "../../../Apis/FreeTextApis";
import { saveToMedHistory } from "../../../Apis/AuthApiServices";
import { useOnBehalfContext } from "../../../context/OnbehalfContext";

const initialStateRxSummary = {
  rxPadNumbers: [],
};

export default function FreeTextMedicationPrescriptionSummary(props: any) {
  const dispatch = useDispatch();
  const { onBehalfContext }: any = useOnBehalfContext();
  const UserServiceState = useSelector((state: any) => {
    return { ...state?.UserServicesSlice?.ServicesData };
  }); //redux data
  const [locationData, setLocationData] = useState<any>(
    JSON.parse(sessionStorage.getItem("locationData")!)
  );
  const [summarySendToPharmacyData, setSendToPharmacyData] = useState<any>([]);
  const [openInfo, setOpenInfo] = useState(true);
  const patientId: any = sessionStorage.getItem("patientId");
  const doctorId: any = localStorage.getItem("doctorId");
  const [ApprovedPopup, setApprovedPopup] = useState(false);
  const [printPop, setPrintPop] = useState(false);
  const handleShowPrintPopupClick = () => {
    setPrintPop(true);
  };
  const handleHidePrintPopupClick = () => {
    setPrintPop(false);
  };
  const handleShowApprovedPopupClick = () => {
    setApprovedPopup(true);
  };
  const handleHideApprovedPopupClick = () => {
    if (summarySendToPharmacyData?.url) {
      setApprovedPopup(false);
      setReportUrl({ reportUrl: summarySendToPharmacyData?.url });
      setPrintActive(true);
    } else {
      navigate("/freetextmedication");
      props.getInitializeRxpad();
      setApprovedPopup(false);
      // setTimeout(() => {
      //   sessionStorage.clear();
      // }, 1000);
    }
  };

  const [StateData, SetStateData] = useState<any>({
    message: "",
    open: false,
    variant: "",
  });
  const handleInfoClick = () => {
    setOpenInfo(!openInfo);
  };
  const navigate = useNavigate();

  useEffect(() => {
    if (locationData?.prescriptionErrors?.length >= 1) {
      SetStateData((prevState: any) => {
        return {
          ...prevState,
          message: locationData?.prescriptionErrors?.map((each: any) => {
            return (
              <Box>
                <Typography
                  component={"div"}
                  fontWeight={600}
                  variant={"body2"}
                >
                  <strong> Rx-{each?.rxNumber}</strong>
                </Typography>
                {each?.errors?.map((ech: any) => {
                  return (
                    <Typography
                      component={"div"}
                      fontWeight={600}
                      variant={"body2"}
                      paddingLeft={2}
                    >
                      {" - "} {ech?.errorMessage}
                    </Typography>
                  );
                })}
              </Box>
            );
          }),
          variant: "error",
          open: true,
        };
      });
    }
  }, [locationData]);

  const [selectedRxNumber, setSelectedRxNUmber] = useState<any>([]);
  const handleChangeCheckBox = (selectedValue: string, e: any) => {
    if (e.target.checked) {
      setSelectedRxNUmber([...selectedRxNumber, selectedValue]);
    } else {
      setSelectedRxNUmber(
        selectedRxNumber.filter((item: any) => item !== selectedValue)
      );
    }
  };

  const addToMedHistory = async () => {
    try {
      const bodyData = {
        prescriptionIds: selectedRxNumber,
        prescriptionFormList: locationData?.prescriptionFormList?.filter(
          (each: any) => selectedRxNumber.includes(each.rxNumber?.toString())
        ),
        patientId: patientId,
        userDetails: {
          doctorId: doctorId,
          onBehalfDoctorId: localStorage.getItem("onBehalf") ?? "",
          selectedClinicId: sessionStorage.getItem("clinicId"),
        },
      };
      const result = await saveToMedHistory(bodyData);
      if (result?.data?.digitalRxStatusCode === 200) {
        await removeRX();
        SetStateData((prevState: any) => {
          return {
            ...prevState,
            message: `Successfully Added ${result?.data?.response[0]}`,
            variant: "success",
            open: true,
          };
        });
      } else {
        SetStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.digitalRxStatusMessage,
            variant: "error",
            open: true,
          };
        });
      }
    } catch (error) {
      SetStateData((prevState: any) => {
        return {
          ...prevState,
          message: "Something went wrong",
          variant: "error",
          open: true,
        };
      });
    }
  };
  const [printActive, setPrintActive] = useState(false);
  const [reportUrl, setReportUrl] = useState<any>({});
  const [printLoad, setPrintLoad] = useState(false);

  const getRxPrint = async () => {
    try {
      setPrintLoad(true);

      const bodyData = {
        prescriptionFormList: locationData?.prescriptionFormList,
        patientId: patientId,
        userDetails: {
          doctorId: doctorId,
          onBehalfDoctorId: localStorage.getItem("onBehalf") ?? "",
          selectedClinicId: sessionStorage.getItem("clinicId"),
        },
      };
      const result = await freeTextPrint(bodyData);
      if (result?.data?.digitalRxStatusCode === 200) {
        setPrintLoad(false);
        setPrintActive(true);
        setReportUrl(result?.data?.response[0]);
        dispatch(loadingTopRibbon());
        handleShowPrintPopupClick();
      } else {
        setPrintActive(false);
        setPrintLoad(false);
        setReportUrl("");
        SetStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.digitalRxStatusMessage,
            variant: "error",
            open: true,
          };
        });
      }
    } catch (error) {
      setPrintActive(false);
      setReportUrl("");
      setPrintLoad(false);
      SetStateData((prevState: any) => {
        return {
          ...prevState,
          message: "Try again after sometime!",
          variant: "error",
          open: true,
        };
      });
    }
  };

  const [smallLoad, setSmallLoad] = useState(false);
  const [smallLoad2, setSmallLoad2] = useState(false);
  const faxAndPrintToPharmacy = async (
    printAndFaxFlag: string,
    faxFlag: string,
    from: string
  ) => {
    setSmallLoad(from === "FTP" ? true : false);
    setSmallLoad2(from === "PF" ? true : false);
    try {
      const params = new URLSearchParams();
      params.append("printAndFax", printAndFaxFlag);
      params.append("faxflag", faxFlag);
      const bodyData = {
        prescriptionFormList: JSON.parse(
          sessionStorage.getItem("locationData")!
        )?.prescriptionFormList,
        patientId: patientId,
        userDetails: {
          doctorId: doctorId,
          onBehalfDoctorId: localStorage.getItem("onBehalf") ?? "",
          selectedClinicId: sessionStorage.getItem("clinicId"),
        },
      };
      const result: any = await freeTextPrintAndFax(params, bodyData);
      if (result?.data?.digitalRxStatusCode === 200) {
        if (result?.data?.response[0]?.prescriptionErrors?.length >= 1) {
          SetStateData((prevState: any) => {
            return {
              ...prevState,
              message: result?.data?.response[0]?.prescriptionErrors?.map(
                (each: any) => {
                  return (
                    <Box>
                      <Typography
                        component={"div"}
                        fontWeight={600}
                        variant={"body2"}
                      >
                        <strong> Rx-{each?.rxNumber}</strong>
                      </Typography>
                      {each?.errors?.map((ech: any) => {
                        return (
                          <Typography
                            component={"div"}
                            fontWeight={600}
                            variant={"body2"}
                            paddingLeft={2}
                          >
                            {" - "} {ech?.errorMessage}
                          </Typography>
                        );
                      })}
                    </Box>
                  );
                }
              ),
              variant: "error",
              open: true,
            };
          });
        } else {
          setSendToPharmacyData(result?.data?.response[0]);
          setSmallLoad(false);
          setSmallLoad2(false);
          handleShowApprovedPopupClick();
          dispatch(loadingTopRibbon());
        }
        setSmallLoad(false);
        setSmallLoad2(false);
      } else {
        setSendToPharmacyData([]);
        setSmallLoad(false);
        setSmallLoad2(false);
        SetStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.digitalRxStatusMessage,
            variant: "error",
            open: true,
          };
        });
      }
    } catch (error) {
      setSendToPharmacyData([]);
      setSmallLoad2(false);
      setSmallLoad(false);
      SetStateData((prevState: any) => {
        return {
          ...prevState,
          message: "something went wrong!",
          variant: "error",
          open: true,
        };
      });
    }
  };

  const removeRX = async () => {
    try {
      const localRx = locationData?.prescriptionFormList?.filter(
        (each: any) => {
          return !selectedRxNumber.includes(each?.rxNumber?.toString());
        }
      );

      var localRx1 = localRx?.map((each: any, index: any) => {
        each.rxNumber = index + 1;
        return each;
      });
      var newRxList1 = localRx?.map((each: any, index: any) => {
        each.rxNumber = index + 1;
        return each;
      });

      sessionStorage.setItem("freeTextRxTabs", JSON.stringify(newRxList1));
      sessionStorage.setItem(
        "locationData",
        JSON.stringify({ ...locationData, prescriptionFormList: localRx1 })
      );
      props.setTabList(newRxList1);
      if (localRx1.length <= 0 || newRxList1.length <= 0) {
        navigate("/freetextmedication");
        props.getInitializeRxpad();
        // sessionStorage.clear();
      } else {
        setTimeout(() => {
          setLocationData(JSON.parse(sessionStorage.getItem("locationData")!));
          setSelectedRxNUmber([]);
        }, 1000);
      }
    } catch (err) {}
  };

  return (
    <>
      {printActive ? (
        <>
          <Grid item xs={12}>
            <iframe
              src={`${REPORT_BASE_URL}${reportUrl?.reportUrl}`}
              height="500px"
              width="100%"
              title="PrintReport"
            />
          </Grid>
          <Grid item xs={12}>
            <BtnGroupStyle className="right">
              <YSButton
                className=""
                children={"Back"}
                variant={"outlined"}
                size={"large"}
                onClick={() => {
                  // sessionStorage.clear();
                  props.getInitializeRxpad();
                  navigate("/freetextmedication");
                  setPrintActive(false);
                }}
              />{" "}
            </BtnGroupStyle>
          </Grid>
        </>
      ) : (
        <Formik
          initialValues={initialStateRxSummary}
          onSubmit={(values) => {
            console.log("time: ", values);
          }}
        >
          {({ handleSubmit }) => (
            <Form onSubmit={handleSubmit}>
              <SummaryInfo>
                {" "}
                <Grid
                  container
                  item
                  xs={12}
                  spacing={1}
                  alignItems="center"
                  justifyContent="flex-start"
                >
                  <Grid item xs={9} md={6}>
                    <Typography
                      component="div"
                      color={"primary"}
                      variant="subtitle2"
                      fontWeight={600}
                    >
                      Allergy and Drug Interactions
                    </Typography>{" "}
                  </Grid>
                  <Grid item xs={3} md={6} textAlign={"right"}>
                    <YSButton
                      onClick={handleInfoClick}
                      className=""
                      children={"Show"}
                      size={"small"}
                      type="button"
                      variant="contained"
                      startIcon={openInfo ? <HideIcon /> : <ShowIcon />}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Collapse in={openInfo}>
                      <DrugAllergyInteractions eachData={locationData} />
                    </Collapse>
                  </Grid>
                </Grid>{" "}
              </SummaryInfo>
              <Grid
                container
                item
                xs={12}
                spacing={2}
                alignItems="center"
                justifyContent="flex-start"
              >
                <Grid item xs={12}>
                  <Typography
                    component="div"
                    color={"primary"}
                    variant="subtitle2"
                    fontWeight={600}
                    marginBottom={1}
                  >
                    Prescriptions Summary
                  </Typography>{" "}
                </Grid>
              </Grid>
              <SummaryBoxScroll>
                {locationData?.prescriptionFormList?.map(
                  (eachItem: any, index: any) => (
                    <SummaryBox key={index}>
                      <Grid
                        container
                        item
                        xs={12}
                        spacing={1}
                        alignItems="flex-start"
                        justifyContent="flex-start"
                      >
                        <Grid item xs={12} md={4}>
                          <Box className="lblval chk">
                            <Typography
                              component="label"
                              variant="body2"
                              fontWeight={600}
                            >
                              <Checkbox
                                className="fill checkbox rxs"
                                name={`rxPadNumbers ${eachItem?.rxNumber}`}
                                checked={selectedRxNumber.includes(
                                  `${eachItem?.rxNumber}`
                                )}
                                onChange={(e: any) => {
                                  handleChangeCheckBox(
                                    `${eachItem?.rxNumber}`,
                                    e
                                  );
                                }}
                              />
                              Rx No
                            </Typography>
                            <Typography component="div" variant="body2">
                              {eachItem?.rxNumber}
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <Box className="lblval">
                            <Typography
                              component="label"
                              variant="body2"
                              fontWeight={600}
                            >
                              Rx Date
                            </Typography>
                            <Typography component="div" variant="body2">
                              {moment(new Date()).format("MM/DD/YYYY")}
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <Box className="lblval">
                            <Typography
                              component="label"
                              variant="body2"
                              fontWeight={600}
                            >
                              Fmlry. Status
                            </Typography>
                            <Typography component="div" variant="body2">
                              {eachItem?.formularyStatus}
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={12} md={8}>
                          <Box className="lblval">
                            <Typography
                              component="div"
                              variant="body2"
                              color={"primary"}
                              fontWeight={600}
                            >
                              {eachItem?.drugName}
                            </Typography>
                            {eachItem?.deaClassCode && (
                              <Typography
                                component="div"
                                className="ScheduledDrugLabel"
                                variant="body2"
                              >
                                {eachItem?.deaClassCode}
                              </Typography>
                            )}
                          </Box>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <Box className="lblval">
                            <Typography
                              component="label"
                              variant="body2"
                              fontWeight={600}
                            >
                              Co-Pay
                            </Typography>{" "}
                            <Typography component="div" variant="body2">
                              {eachItem?.copay}
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <Box className="lblval">
                            <Typography
                              component="label"
                              variant="body2"
                              fontWeight={600}
                            >
                              SIG
                            </Typography>{" "}
                            <Typography component="div" variant="body2">
                              {eachItem?.sig}
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <Box className="lblval">
                            <Typography
                              component="label"
                              variant="body2"
                              fontWeight={600}
                            >
                              Qualifier
                            </Typography>{" "}
                            <Typography component="div" variant="body2">
                              {eachItem?.qtyQualifier}
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <Box className="lblval">
                            <Typography
                              component="label"
                              variant="body2"
                              fontWeight={600}
                            >
                              Quantity
                            </Typography>{" "}
                            <Typography component="div" variant="body2">
                              {eachItem?.quantity}
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <Box className="lblval">
                            <Typography
                              component="label"
                              variant="body2"
                              fontWeight={600}
                            >
                              No. Of Refills
                            </Typography>{" "}
                            <Typography component="div" variant="body2">
                              {eachItem?.refills}
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <Box className="lblval">
                            <Typography
                              component="label"
                              variant="body2"
                              fontWeight={600}
                            >
                              Substitutions
                            </Typography>{" "}
                            <Typography component="div" variant="body2">
                              {eachItem?.substitution}
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <Box className="lblval">
                            <Typography
                              component="div"
                              variant="body2"
                              fontWeight={600}
                            >
                              Note to Pharmacist
                            </Typography>{" "}
                            <Typography component="div" variant="body2">
                              {eachItem?.instructions}
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <Box className="lblval">
                            <Typography
                              component="label"
                              variant="body2"
                              fontWeight={600}
                            >
                              Pharmacy
                            </Typography>{" "}
                            <HtmlTooltip
                              placement="right"
                              arrow
                              title={
                                eachItem?.pharmacyDetails ? (
                                  <PharmacyDetails
                                    row={eachItem?.pharmacyDetails}
                                  />
                                ) : (
                                  "Not Selected"
                                )
                              }
                              className="w316"
                            >
                              {eachItem?.pharmacyDetails ? (
                                <Typography
                                  component="div"
                                  variant="body2"
                                  color={"primary"}
                                >
                                  {eachItem?.pharmacyDetails?.pharmacyName}
                                </Typography>
                              ) : (
                                <Typography
                                  component="div"
                                  variant="body2"
                                  color={"error"}
                                >
                                  Not Selected
                                </Typography>
                              )}
                            </HtmlTooltip>
                          </Box>
                        </Grid>
                      </Grid>
                    </SummaryBox>
                  )
                )}
              </SummaryBoxScroll>{" "}
              <AlertInfo marginBottom={1} marginTop={1}>
                <img src={AlertInfoIcon} alt="Alert" loading="lazy" />
                <Typography color={"error"}>
                  Options below with * requires the Rx No boxes to be checked
                  for processing. For other options, checking the box will not
                  have any effect.
                </Typography>
              </AlertInfo>
              <SummaryBtns>
                <YSButton
                  children={"* Remove"}
                  onClick={() => {
                    if (selectedRxNumber.length >= 1) {
                      removeRX();
                    } else {
                      SetStateData((prevState: any) => {
                        return {
                          ...prevState,
                          message: "Please Select at least one prescription!",
                          variant: "error",
                          open: true,
                        };
                      });
                    }
                  }}
                  variant={"outlined"}
                  size={"large"}
                  startIcon={
                    <img src={TrashIcon} alt="Delete" loading="lazy" />
                  }
                />
                {/* <YSButton
                  size="large"
                  variant="outlined"
                  disabled={false}
                  type="button"
                  children={"View Rx"}
                  onClick={saveToSavedPrescriptions}
                  startIcon={<img src={ShowPasswordIcon} alt="Save" />}
                /> */}
                <YSButton
                  children={
                    printLoad ? (
                      <CircularProgress color="primary" size={28} />
                    ) : (
                      "Print"
                    )
                  }
                  onClick={() => {
                    getRxPrint();
                  }}
                  disabled={
                    // (UserServiceState?.allowedToPrint
                    //   ? UserServiceState?.allowedToPrintControlledSubstances ===
                    //       false &&
                    //     locationData?.popUpFlag?.scheduleDrug === true
                    //     ? true
                    //     : false
                    //   : true) ?? false
                    onBehalfContext?.id &&
                    UserServiceState?.profileGroup !== 11 &&
                    !locationData?.popUpFlag?.stateMandateDisableFlag
                      ? false
                      : UserServiceState?.profileGroup > 6 ||
                        locationData?.popUpFlag?.stateMandateDisableFlag
                      ? true
                      : false

                    // (onBehalfContext?.id && UserServiceState?.profileGroup != 11
                    //   ? false
                    //   : UserServiceState?.profileGroup > 6
                    //   ? true
                    //   : UserServiceState?.allowedToPrint
                    //   ? UserServiceState?.allowedToPrintControlledSubstances ===
                    //       false &&
                    //     locationData?.popUpFlag?.scheduleDrug === true
                    //     ? true
                    //     : false
                    //   : true) ?? false
                  }
                  variant={"outlined"}
                  size={"large"}
                  startIcon={
                    onBehalfContext?.id &&
                    UserServiceState?.profileGroup !== 11 &&
                    !locationData?.popUpFlag?.stateMandateDisableFlag ? (
                      <img src={PrintIcon} alt="print1" loading="lazy" />
                    ) : UserServiceState?.profileGroup > 6 ||
                      locationData?.popUpFlag?.stateMandateDisableFlag ? (
                      <LockIcon />
                    ) : (
                      <img src={PrintIcon} alt="print" loading="lazy" />
                    )
                  }
                />
                <YSButton
                  onClick={() => {
                    faxAndPrintToPharmacy("true", "false", "PF");
                  }}
                  className=""
                  children={
                    smallLoad2 ? (
                      <CircularProgress color="primary" size={28} />
                    ) : (
                      "Fax & Print"
                    )
                  }
                  disabled={
                    locationData?.popUpFlag?.faxAndPrint &&
                    !locationData?.popUpFlag?.stateMandateDisableFlag
                      ? false
                      : locationData?.popUpFlag?.stateMandateDisableFlag
                      ? true
                      : false
                  }
                  startIcon={
                    locationData?.popUpFlag?.faxAndPrint &&
                    !locationData?.popUpFlag
                      ?.stateMandateDisableFlag ? null : locationData?.popUpFlag
                        ?.stateMandateDisableFlag ? (
                      <LockIcon />
                    ) : null
                  }
                  size={"large"}
                  type="button"
                  color="primary"
                  variant="outlined"
                />
                <YSButton
                  onClick={() => {
                    addToMedHistory();
                  }}
                  className=""
                  children={"* Add to Medication History"}
                  size={"large"}
                  type="submit"
                  color="primary"
                  variant="outlined"
                  startIcon={<AddCircleOutlineOutlinedIcon />}
                />
                <YSButton
                  onClick={() => {
                    faxAndPrintToPharmacy("false", "true", "FTP");
                  }}
                  className=""
                  children={
                    smallLoad ? (
                      <CircularProgress color="inherit" size={28} />
                    ) : (
                      "Fax to Pharmacy"
                    )
                  }
                  disabled={
                    locationData?.popUpFlag?.faxToPharmacy &&
                    !locationData?.popUpFlag?.stateMandateDisableFlag
                      ? false
                      : locationData?.popUpFlag?.stateMandateDisableFlag
                      ? true
                      : false
                  }
                  size={"large"}
                  type="button"
                  color="primary"
                  variant="contained"
                  startIcon={
                    locationData?.popUpFlag?.faxToPharmacy &&
                    !locationData?.popUpFlag?.stateMandateDisableFlag ? (
                      <img src={SendPharmacyIcon} alt="Send to Pharmacy" />
                    ) : locationData?.popUpFlag?.stateMandateDisableFlag ? (
                      <LockIcon />
                    ) : (
                      <img
                        src={SendPharmacyIcon}
                        alt="Send to Pharmacy"
                        loading="lazy"
                      />
                    )
                  }
                />
              </SummaryBtns>
            </Form>
          )}
        </Formik>
      )}
      {/* Approved FTP POPup */}
      <DialogPopup
        title="Prescribed Status"
        windowsize={"sm"}
        show={ApprovedPopup}
        handleShowPopupClick={handleShowApprovedPopupClick}
        handleHidePopupClick={handleHideApprovedPopupClick}
      >
        <Grid
          container
          item
          xs={12}
          spacing={1}
          alignItems="top"
          justifyContent="center"
        >
          <Grid item xs={12} textAlign={"center"}>
            <CheckCircleOutlineIcon
              style={{ height: 70, width: 70 }}
              color="success"
            />
          </Grid>
          <>
            {summarySendToPharmacyData?.epaReturnList?.successMedicationList
              ?.length >= 1 && (
              <Grid item xs={12} textAlign={"left"}>
                <Typography component="span" variant="subtitle2">
                  Drug(s):{" "}
                  <strong>
                    {summarySendToPharmacyData?.epaReturnList?.successMedicationList?.join(
                      ", "
                    )}
                  </strong>{" "}
                  {`-> Required EPA,prescription added to Holding
                  queue.`}
                </Typography>
              </Grid>
            )}
            {summarySendToPharmacyData?.epaReturnList?.failureMedicationList
              ?.length >= 1 && (
              <Grid item xs={12} textAlign={"left"}>
                <Typography component="span" variant="subtitle2">
                  Drug(s):{" "}
                  <strong>
                    {summarySendToPharmacyData?.epaReturnList?.failureMedicationList?.join(
                      ", "
                    )}
                  </strong>{" "}
                  - EPA failure List: Prescriptions failed to add to Holding
                  queue.
                </Typography>
              </Grid>
            )}
            {summarySendToPharmacyData?.epcsReturnList?.successMedicationList
              ?.length >= 1 && (
              <Grid item xs={12} textAlign={"left"}>
                <Typography component="span" variant="subtitle2">
                  Drug(s):{" "}
                  <strong>
                    {summarySendToPharmacyData?.epcsReturnList?.successMedicationList?.join(
                      ", "
                    )}
                  </strong>
                  - EPCS success list: Prescriptions added to EPCS Queue
                </Typography>
              </Grid>
            )}
            {summarySendToPharmacyData?.epcsReturnList?.failureMedicationList
              ?.length >= 1 && (
              <Grid item xs={12} textAlign={"left"}>
                <Typography component="span" variant="subtitle2">
                  Drug(s):{" "}
                  <strong>
                    {summarySendToPharmacyData?.epcsReturnList?.failureMedicationList?.join(
                      ", "
                    )}
                  </strong>
                  - EPCS Failure LIst : Failed to add prescriptions to EPCS
                  Queue
                </Typography>
              </Grid>
            )}
            {summarySendToPharmacyData?.epcsWithEpaReturnList
              ?.successMedicationList?.length >= 1 && (
              <Grid item xs={12} textAlign={"left"}>
                <Typography component="span" variant="subtitle2">
                  Drugs(s):{" "}
                  <strong>
                    {summarySendToPharmacyData?.epcsWithEpaReturnList?.successMedicationList?.join(
                      ", "
                    )}
                  </strong>{" "}
                  - Prescriptions added to EPCS queue and added to EPA Holding
                  queue successfully.
                </Typography>
              </Grid>
            )}
            {summarySendToPharmacyData?.epcsWithEpaReturnList
              ?.failureMedicationList?.length >= 1 && (
              <Grid item xs={12} textAlign={"left"}>
                <Typography component="span" variant="subtitle2">
                  Drug(s):
                  <strong>
                    {summarySendToPharmacyData?.epcsWithEpaReturnList?.failureMedicationList?.join(
                      ", "
                    )}
                  </strong>
                  - Prescriptions added to EPCS Queue and failed to add into EPA
                  Holding Queue.
                </Typography>
              </Grid>
            )}
            {summarySendToPharmacyData?.postDatedReturnList
              ?.successMedicationList?.length >= 1 && (
              <Grid item xs={12} textAlign={"left"}>
                <Typography component="span" variant="subtitle2">
                  Drug(s):
                  <strong>
                    {summarySendToPharmacyData?.postDatedReturnList?.successMedicationList?.join(
                      ", "
                    )}
                  </strong>
                  - Prescription added as Post dated prescription
                </Typography>
              </Grid>
            )}
            {summarySendToPharmacyData?.postDatedReturnList
              ?.failureMedicationList?.length >= 1 && (
              <Grid item xs={12} textAlign={"left"}>
                <Typography component="span" variant="subtitle2">
                  Drug(s):
                  <strong>
                    {summarySendToPharmacyData?.postDatedReturnList?.failureMedicationList?.join(
                      ", "
                    )}
                  </strong>{" "}
                  - Prescription failed to add as Post dated prescription
                </Typography>
              </Grid>
            )}
            {summarySendToPharmacyData?.electronicReturnList?.length >= 1 && (
              <Grid item xs={12} textAlign={"left"}>
                <Typography
                  component="div"
                  variant="subtitle2"
                  fontWeight={600}
                >
                  Drugs sent electronically:
                </Typography>
                {summarySendToPharmacyData?.electronicReturnList?.map(
                  (each: any) => (
                    <ul>
                      <li>{each}</li>
                    </ul>
                  )
                )}
              </Grid>
            )}
            {summarySendToPharmacyData?.faxReturnList?.length >= 1 && (
              <Grid item xs={12} textAlign={"left"}>
                <Typography
                  component="div"
                  variant="subtitle2"
                  fontWeight={600}
                >
                  Drugs faxed electronically:
                </Typography>
                {summarySendToPharmacyData?.faxReturnList?.map((each: any) => (
                  <ul>
                    <li>{each}</li>
                  </ul>
                ))}
              </Grid>
            )}
            {summarySendToPharmacyData?.printReturnList?.length >= 1 && (
              <Grid item xs={12} textAlign={"left"}>
                <Typography
                  component="div"
                  variant="subtitle2"
                  fontWeight={600}
                >
                  Drugs to be printed:
                </Typography>
                {summarySendToPharmacyData?.printReturnList?.map(
                  (each: any) => (
                    <ul>
                      <li>{each}</li>
                    </ul>
                  )
                )}
              </Grid>
            )}
            {summarySendToPharmacyData?.rejectedList?.length >= 1 && (
              <Grid item xs={12} textAlign={"left"}>
                <Typography
                  component="div"
                  variant="subtitle2"
                  fontWeight={600}
                >
                  {UserServiceState?.allowedToPrint ? (
                    <Typography
                      component="div"
                      variant="subtitle2"
                      color={"error"}
                      fontWeight={500}
                    >
                      As per State regulatory, All Controlled substance
                      prescriptions must be sent electronically only.
                    </Typography>
                  ) : (
                    <Typography
                      component="div"
                      variant="subtitle2"
                      color={"error"}
                      fontWeight={500}
                    >
                      As per State regulatory, All prescriptions must be sent
                      electronically only.
                    </Typography>
                  )}
                  Drugs rejected:
                </Typography>
                {summarySendToPharmacyData?.rejectedList?.map((each: any) => (
                  <ul>
                    <li>{each}</li>
                  </ul>
                ))}
                <Typography
                  component="div"
                  variant="subtitle2"
                  color={"error"}
                  fontWeight={600}
                >
                  Please RE-PRESCRIBE the rejected drugs.
                </Typography>
              </Grid>
            )}
          </>
        </Grid>
      </DialogPopup>
      {/* Print PopUP */}
      <DialogPopup
        title="Print Status"
        windowsize={"sm"}
        show={printPop}
        handleShowPopupClick={handleShowPrintPopupClick}
        handleHidePopupClick={handleHidePrintPopupClick}
      >
        <>
          <Grid item xs={12} textAlign={"center"}>
            <CheckCircleOutlineIcon
              style={{ height: 70, width: 70 }}
              color="success"
            />
          </Grid>
          {reportUrl?.printReturnList && (
            <>
              <Grid item xs={12} textAlign={"left"}>
                <Typography
                  component="div"
                  variant="subtitle2"
                  fontWeight={600}
                >
                  Drugs to be printed:
                </Typography>
                <ul>
                  {reportUrl?.printReturnList?.map((each: any) => (
                    <>
                      <li>{each}</li>
                    </>
                  ))}
                </ul>
              </Grid>
            </>
          )}
        </>
      </DialogPopup>

      <YSSnackBar
        message={StateData.message}
        variant={StateData.variant}
        open={StateData.open}
        handleClose={() => {
          SetStateData((prevState: any) => {
            return { ...prevState, open: false };
          });
        }}
      />
    </>
  );
}

const PharmacyDetails = (props: any) => {
  const { row } = props;
  return (
    <Grid container rowSpacing={1} columnSpacing={2}>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Name:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {row?.pharmacyName ?? "Not Available"}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          24 Hours Service:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {row?.twentyFourHourFlag ?? "Not Available"}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Store:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {row?.storeNo ?? "Not Available"}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Address:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {row?.pharmacyAddress ?? "Not Available"}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Land Mark:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {row?.landMark ?? "Not Available"}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          City:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {row?.city ?? "Not Available"}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          State:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {row?.state ?? "Not Available"}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Zip:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {row?.zip ?? "Not Available"}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Phone:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {row?.pharmacyPhone ?? "Not Available"}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Fax:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {row?.faxNo ?? "Not Available"}
        </Typography>
      </Grid>
    </Grid>
  );
};
